// This is generated.  Alter it in blockGroups/filters/types/ByCurrentRoute.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};
    const { id, propertyName } = hNode;

    // whatever the relation context we are in, it is expected to have `propertyName` as (string) property
    const routeSchema = Type.String({
      'x-id': id,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
    });

    const partialTypeDefinition = {
      [propertyName]: routeSchema,
    };

    //And the given foreignKey exists on the parent object.
    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'filters',
  'ByCurrentRoute',
  module.exports,
);
